import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Leaf } from "lucide-react";
import { API } from "@/auth";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [pending, setPending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setPending(true);
    try { await axios.post(`${API}/auth/forgot-password`, { email }); } catch {}
    setSent(true);
    setPending(false);
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center px-4 py-12">
      <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
        <Leaf className="w-7 h-7 text-green-600" />
      </div>
      <h1 className="text-2xl font-semibold text-slate-900 mt-5 text-center">Reset your password</h1>
      <p className="text-sm text-slate-500 mt-1.5 text-center">Enter your registered work email — we'll send a reset link.</p>

      <div className="w-full max-w-sm bg-white border border-slate-200 rounded-2xl shadow-sm p-6 mt-8">
        {sent ? (
          <div data-testid="forgot-success-message" className="p-4 rounded-xl border border-emerald-200 bg-emerald-50">
            <div className="text-sm font-semibold text-emerald-900">Check your inbox</div>
            <p className="text-xs text-emerald-800 mt-1.5">If that email is registered, a reset link has been sent. It expires in 1 hour and works once.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-[11px] uppercase tracking-widest font-semibold text-slate-500 mb-1.5">Work Email</label>
              <Input type="email" required value={email} onChange={e => setEmail(e.target.value)}
                className="h-11 rounded-xl bg-white" data-testid="forgot-email-input" />
            </div>
            <button type="submit" disabled={pending} data-testid="forgot-submit-button"
              className="w-full h-11 rounded-xl bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium transition-colors disabled:opacity-60">
              {pending ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}
        <div className="text-center mt-4">
          <Link to="/login" className="text-sm text-blue-600 hover:underline" data-testid="back-to-login-link">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
